exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-32b52b88] {\n  text-align: right;\n  margin-right: 25px;\n}\n.select-item[data-v-32b52b88] {\n  width: 280px;\n  padding: 10px;\n  margin: 0 auto 10px auto;\n  border: 1px solid #eaeaea;\n}\n.select-item2[data-v-32b52b88] {\n  padding: 10px;\n  margin: 0 auto 10px auto;\n  border: 1px solid #eaeaea;\n}\n.ope-row[data-v-32b52b88] {\n  padding-top: 10px;\n  text-align: center;\n}\n.item-name[data-v-32b52b88] {\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n}", ""]);

// exports
